import { EntityBase } from './entity-base.model';

export class SaveReportFile extends EntityBase {
  SystemKindName: string;
  FileName: string;
  FileInfo: string;
  CategoryName: string;
  ReportTitle: string;
  DataSourceName: string;
  startDate?: Date;
  endDate?: Date;
  startNumber?: number;
  endNumber?: number;
}
